import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { CommonService } from '../../../../../core/services/common.service';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { StatePersistingService } from '../../../../../core/services/state-persisting.service';
import { UserService } from '../../../../../core/services/user.service';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings } from '../../../../../core/common';
import { FreightClaimDetails, FreightClaimHeader, ICustomer, IFreightOrder, IGetOrdersInquiryBody, IOrderInquiry, IOrderInquiryDetailsLbl, IOrderInquiryLbl } from '../../../../../core/models';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { OrderService } from '../../../../../core/services/order.service';
import { FreightClaimService } from '../../../../../core/services/freight-claim.service';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-review-completed-claim-details',
  templateUrl: './review-completed-claim-details.component.html',
  styleUrls: ['./review-completed-claim-details.component.scss']
})
export class ReviewCompletedClaimDetailsComponent implements OnInit {
  trackShipmentTabGridData: GridDataResult;
  claimItemGridLoading: boolean = false;
  loadingPDF: boolean;
  loadingExcel: boolean;
  public trackShipmentGridData: FreightClaimDetails[] = [];

  order: IFreightOrder;
  claimTypeDdlData: { name: string, value: string }[] = [];
  selectedLinesForClaim: any = [];
  fullCustomerName: string = '';
  fullShipToAddress: string = '';
  shipToAddress: ICustomer;
  claimComment: string;
  selectedClaimId: string = '100004';
  claim: FreightClaimHeader;
  claimNum: string = '';

  constructor(private orderService: OrderService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private userService: UserService,
    //public persistingService: StatePersistingService,
    private languageTranslationService: LanguageTranslationService,
    private cp: CurrencyPipe,
    private freightClaimService: FreightClaimService) {
    this.route.queryParamMap.subscribe(params => {
      //console.log(params);
      this.claimNum = params.get('claimId') || 'ttt';
      //this.confirmatioNumber = params.get('Confirmation Number') || '';
      console.log(this.claimNum);
      //console.log("completion trackerid=" + this.trackerId);
    });
  }

  ngOnInit() {
    this.claim = new FreightClaimHeader();
    this.selectedClaimId = this.freightClaimService.claimHeaderId || '-1';
    if (this.selectedClaimId == '-1') {
      this.router.navigate(['/view-claim-history']);
      return;
    }
    console.log(this.selectedClaimId);
    this.loadClaimDetails();
  }

  public loadClaimDetails(): void {
    this.claimItemGridLoading = true;
    this.freightClaimService.getMyClaimsDetailsForProcessing(this.selectedClaimId).subscribe((response) => {
      this.claimItemGridLoading = false;
      if (response) {
        console.log(response);
        this.claim = response;
        this.claim.scheduleDate = this.claim.scheduleDate ? new Date(this.claim.scheduleDate) : null;
        this.trackShipmentGridData = response.details;
        this.trackShipmentGridData.forEach((el, index) => {
          el.shipDate = el.shipDate ? new Date(el.shipDate) : null;
          el.items.forEach((item, i) => {
            this.freightClaimService.setAdditionalProps(item);
          });
          this.freightClaimService.setTotal(el);
        });      
        this.loadClaimedItemGridData();
      }


    }, error => { this.claimItemGridLoading = false; })
  }


  //#region pagination, sorting,filtering,columnReorder,columnVisibilityChange for shipment grid

  public trackShipmentGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'orderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public loadClaimedItemGridData(): void {
    this.trackShipmentTabGridData = process(this.trackShipmentGridData, this.trackShipmentGridstate);
  }

  public trackShipmentGridSortChange(sort): void {
    this.trackShipmentGridstate.sort = sort;
    this.loadClaimedItemGridData();
  }

  public trackShipmentGridPageChange({ skip, take }: PageChangeEvent): void {
    this.trackShipmentGridstate.skip = skip;
    this.trackShipmentGridstate.take;
    this.loadClaimedItemGridData();
  }
  
  public openDocument(pathName: any) {
    
    const body = {
      Url: pathName,
    }
    this.freightClaimService.getDocument(body).subscribe((response) => {
      if (response) {
        console.log(response);
        const blob: Blob = (response && (response as any).body)
          ? (response as any).body
          : (response as Blob);
        if (blob) {
          console.log(blob.type);
          const fileName = 'download';
          //const fileName = ((child && child.partNo) ? partNo : 'download');
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 5000);

          //const downloadLink = document.createElement('a');
          //downloadLink.href = url;
          //downloadLink.download = fileName;
          //downloadLink.click();
          //window.URL.revokeObjectURL(url);
        }
      }
    });
  }
  public trackShipmentDataStateChange(state: DataStateChangeEvent): void {
    this.trackShipmentGridstate = state;
    this.loadClaimedItemGridData();
  }

  public onShipmentReorder(e: any): void {
    //not needed
    //const reorderedColumn = this.gridShipmentSettings.columnsConfig.splice(e.oldIndex, 1);
    //this.gridShipmentSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    //this.saveGrid();
  }
  public onShipmentVisibilityChange(e: any): void {
    //not needed

    //e.columns.forEach(column => {
    //  this.gridShipmentSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    //});
    //this.saveTrackShipmentGrid();
  }

  //#endregion
  //#region label declaration
  public orderDetail = {
    orderHeaderLbl: 'Order Header',
    billingAddressLbl: 'Billing Address',
    shippingAddressLbl: 'Shipping Address',
    soLbl: 'SO #',
    poLbl: 'PO #',
    shippingFromLbl: 'Shipping From',
    jobNumberLbl: 'Job Number',
    cscNameLbl: 'CSC Name',
    cscPhoneLbl: 'CSC Phone',
    OrderDateLbl: 'Order Date',
    orderDetailsLbl: 'Order Details',
    invoiceDetailsLbl: 'Invoice Details',
    trackShipmentLbl: 'Track Shipments',
    exportToPdfLbl: 'Export to PDF',
    exportToExcelLbl: 'Export to Excel',
    lineLbl: 'Line #',
    orderDateLbl: 'Order Date',
    scheduleDateLbl: 'Schedule Date',
    qtyLbl: 'Qty',
    uomLbl: 'UoM',
    itemLbl: 'Item #',
    paintLbl: 'Paint Code',
    listPriceLbl: 'Unit List Price',
    itemDescLbl: 'Item Desc',
    multiplierLbl: 'Multiplier',
    statusLbl: 'Status',
    shipDateLbl: 'Ship Date',
    invoiceNumberLbl: 'Invoice #',
    orderTypeLbl: 'Order Type',
    descriptionLbl: 'Description',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    shipFromLbl: 'Ship From',
    shipmentIdLbl: 'Shipment ID',
    carrierLbl: 'Carrier',
    proNoLbl: 'Pro No.',
    billOfLading: 'Bill Of Lading',
    noOfBoxesLbl: 'No.Of Boxes',
    totalWeightLbl: 'Total Weight',
    totalPriceLbl: 'Total Price',
    grossAmountLbl: 'Gross Amount',
    taxableAmountLbl: 'Taxable Amount',
    invoiceDateLbl: 'Invoice Date',
    openAmountLbl: 'Open Amount',
    taxLbl: 'Tax',
    nonTaxableLbl: 'Non-Taxable Amount',
    kdRefLbl: 'KD Reference Number',
    customerNumberLbl: 'Customer Number',
    relatedInvoiceLbl: 'Related Invoices',
    customerNameLbl: 'Customer Name',
  };

  orderDetailTxt: IOrderInquiryDetailsLbl = {
    orderHeaderLbl: '',
    billingAddressLbl: '',
    shippingAddressLbl: '',
    soLbl: '',
    poLbl: '',
    shippingFromLbl: '',
    jobNumberLbl: '',
    OrderDateLbl: '',
    orderDetailsLbl: '',
    invoiceDetailsLbl: '',
    trackShipmentLbl: '',
    exportToPdfLbl: '',
    exportToExcelLbl: '',
    lineLbl: '',
    orderDateLbl: '',
    scheduleDateLbl: '',
    qtyLbl: '',
    uomLbl: '',
    itemLbl: '',
    paintLbl: '',
    listPriceLbl: '',
    itemDescLbl: '',
    multiplierLbl: '',
    statusLbl: '',
    shipDateLbl: '',
    invoiceNumberLbl: '',
    orderTypeLbl: '',
    descriptionLbl: '',
    unitPriceLbl: '',
    extendedPriceLbl: '',
    shipFromLbl: '',
    shipmentIdLbl: '',
    carrierLbl: '',
    proNoLbl: '',
    billOfLading: '',
    noOfBoxesLbl: '',
    totalWeightLbl: '',
    cscNameLbl: '',
    cscPhoneLbl: '',
    totalPriceLbl: '',
    grossAmountLbl: '',
    taxableAmountLbl: '',
    invoiceDateLbl: '',
    openAmountLbl: '',
    taxLbl: '',
    nonTaxableLbl: '',
    kdRefLbl: '',
    customerNumberLbl: '',
    customerNameLbl: '',
    relatedInvoiceLbl: '',
  }

  public trackShipmentTabGridColumnLbl = {
    shipmentId: 'Shipment ID',
    carrier: 'Carrier',
    proNo: 'Pro No.',
    billOfLoading: 'Bill Of Loading',
    noOfBoxes: 'No. Of Boxes',
    totalWeight: 'Total Weight',
    shipDate: 'Ship Date'
  };
  //#endregion
  //#region Grid Settings 
  public gridShipmentSettings: GridSettings = {
    state: this.trackShipmentGridstate,
    gridData: process(this.trackShipmentGridData, this.trackShipmentGridstate),
    columnsConfig: [{
      field: 'shipmentId',
      title: this.orderDetailTxt.shipmentIdLbl ? this.orderDetailTxt.shipmentIdLbl : this.orderDetail.shipmentIdLbl,
      filterable: true
    },
    {
      field: 'carrier',
      title: this.orderDetailTxt.carrierLbl ? this.orderDetailTxt.carrierLbl : this.orderDetail.carrierLbl,
      filterable: true
    },
    {
      field: 'proNo',
      title: this.orderDetailTxt.proNoLbl ? this.orderDetailTxt.proNoLbl : this.orderDetail.proNoLbl,
      filterable: true
    },
    {
      field: 'billOfLading',
      title: this.orderDetailTxt.billOfLading ? this.orderDetailTxt.billOfLading : this.orderDetail.billOfLading,
      filterable: true
    },
    {
      field: 'noOfBoxes',
      title: this.orderDetailTxt.noOfBoxesLbl ? this.orderDetailTxt.noOfBoxesLbl : this.orderDetail.noOfBoxesLbl,
      filterable: true
    },
    {
      field: 'totalWeight',
      title: this.orderDetailTxt.totalWeightLbl ? this.orderDetailTxt.totalWeightLbl : this.orderDetail.totalWeightLbl,
      filterable: true
    },
    {
      field: 'shipDate',
      title: this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl,
      _width: 220,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    }
    ]
  };
  //#endregion


  goBack() {
    this.router.navigate(['/view-claim-history']);
  }


}
